module.exports = __webpack_public_path__ + "media/images/locations/sm/japan-b9958641b05f6886e716ec6704b9ecc5.jpg";